<template>
  <div>
    <Incuse/>

    <Donative/>
  </div>
</template>

<script setup>
  import Incuse from '@/components/Informative/Incuse.vue'
  import Donative from '@/components/Form/Donative.vue'
</script>